import { createContext } from "react";

/**
 * bannerStatus:
 * - "loading": estamos precargando el banner real
 * - "ready": banner real listo para render
 * - "fallback": falló la carga, usamos cabezalEnBlanco
 */
const BannerContext = createContext({
  bannerUrl: null,
  bannerStatus: "loading",
  setBannerUrl: () => {},
  setBannerStatus: () => {},
});

export default BannerContext;
